import './Table.css';

export const Table = ({ data = [], className = '', id }) => {
  if (!data || data.length === 0) {
    return null;
  }

  // Array of arrays format: [['Header1', 'Header2'], ['val1', 'val2'], ...]
  const headers = data[0];
  const bodyData = data.slice(1);

  return (
    <div className={`table ${className}`.trim()} id={id}>
      <div className="table__header">
        {headers.map((header, index) => (
          <div key={index} className="table__header-cell">
            {header}
          </div>
        ))}
      </div>
      <div className="table__body">
        {bodyData.map((row, rowIndex) => (
          <div key={rowIndex} className="table__row">
            {row.map((cell, cellIndex) => (
              <div key={cellIndex} className="table__cell">
                {cell}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

